import NavBar from '../features/navbar/Navbar';
import UserOrders from '../features/user/components/UserOrders';

function UserOrdersPage() {
  return (
    <div>
        <UserOrders></UserOrders>
    </div>
  );
}

export default UserOrdersPage;
